import { IDataItem, DataCollection, DataEvents, DragEvents, IDataEventsHandlersMap, IDragEventsHandlersMap, IDragConfig } from "@dhx/ts-data";
import { IEventSystem } from "@dhx/ts-common/events";
import { SelectionEvents, ISelectionEventsHandlersMap } from "@dhx/ts-common/types";

export enum ListEvents {
	click = "click",
	doubleClick = "doubleclick",
	contextmenu = "contextmenu",
	focusChange= "focuschange",
	beforeEditStart = "beforeEditStart",
	afterEditStart = "afterEditStart",
	beforeEditEnd = "beforeEditEnd",
	afterEditEnd = "afterEditEnd"
}

export interface IListConfig extends IDragConfig {
	template?: (obj: IDataItem) => string;
	data?: DataCollection<any> | any[];
	virtual?: boolean;
	itemHeight?: number | string;
	css?: string;
	height?: number | string;
	selection?: ISelectionConfig;
	multiselection?: boolean;
	multiselectionMode?: "click" | "ctrlClick";
	keyNavigation?: boolean | (() => boolean); // when return true, navigation work
	editing?: boolean;
}

export interface IListEventHandlersMap {
	[key: string]: (...args: any[]) => any;
	[ListEvents.click]: (id: string, e: Event) => any;
	[ListEvents.doubleClick]: (id: string, e: Event) => any;
	[ListEvents.contextmenu]: (id: string, e: MouseEvent) => any;
	[ListEvents.focusChange]: (focusIndex: number, id: string) => any;
	[ListEvents.beforeEditStart]: (id: string) => void | boolean;
	[ListEvents.afterEditStart]: (id: string) => void;
	[ListEvents.beforeEditEnd]: (value: any, id: string) => void | boolean;
	[ListEvents.afterEditEnd]: (value: any, id: string) => void;
}

export interface ISelectionConfig {
	multiselection?: boolean;
	multiselectionMode?: "click" | "ctrlClick";
}

export interface IList<T = any> {
	config: IListConfig;
	data: DataCollection<T>;
	events: IEventSystem<DataEvents | ListEvents | DragEvents, IListEventHandlersMap & IDataEventsHandlersMap & IDragEventsHandlersMap>;
	selection: ISelection;
	paint(): void;
	edit(id: string): void;
	getFocusItem(): T;
	destructor(): void;
	setFocus(id: string): void;
	getFocus(): string;

	// TODO: remove sute_7.0
	getFocusIndex(): number;
	setFocusIndex(index: number): void;
}

export interface ISelection<T = any> {
	config: ISelectionConfig;
	events: IEventSystem<SelectionEvents | DataEvents, ISelectionEventsHandlersMap & IDataEventsHandlersMap>;

	getId(): string | string[];
	getItem(): T;
	contains(id?: string): boolean;
	remove(id?: string): boolean;
	add(id?: string, isShift?: boolean, isCtrl?: boolean): void;
}

export interface IListItem {
	[key:string]:any;
}